import { useFliptFeature, type FliptFeature } from "~/hooks/useFliptFeature";
import { FLIPT_ROUTE_KEYS } from "~/router/constants";

export type ManifoldNextGenFeature = FliptFeature;

/**
 * Flipt `manifold-nextgen`, read at the router to gate `/nova` routes.
 */
export const useManifoldNextGenFeature = (): ManifoldNextGenFeature =>
  useFliptFeature(FLIPT_ROUTE_KEYS.MANIFOLD_NEXTGEN);

/**
 * Flipt `force-manifold-nextgen`, targeted at a Flipt segment (e.g. trial
 * users). When enabled, the user is locked into the new experience: the
 * opt-in prompt is skipped and "Switch to classic look" is hidden.
 */
export const useForceManifoldNextGenFeature = (): ManifoldNextGenFeature =>
  useFliptFeature(FLIPT_ROUTE_KEYS.FORCE_MANIFOLD_NEXTGEN);
